import { render, staticRenderFns } from "./TramiteList.vue?vue&type=template&id=653e3765&scoped=true&"
import script from "./TramiteList.vue?vue&type=script&lang=js&"
export * from "./TramiteList.vue?vue&type=script&lang=js&"
import style0 from "./TramiteList.vue?vue&type=style&index=0&id=653e3765&lang=scss&scoped=true&"
import style1 from "./TramiteList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./TramiteList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e3765",
  null
  
)

export default component.exports